// extracted by mini-css-extract-plugin
export default {"container":"film-details_container__1NHsU","list":"film-details_list__Fs7pC","split":"film-details_split__3RNaM","section":"film-details_section__3W2DG"};